// extracted by mini-css-extract-plugin
export var item = "post-module--item--R4YCK";
export var wide = "post-module--wide--cWTfG";